import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { AbstractControl, FormControl, ReactiveFormsModule } from "@angular/forms";
import { MatRadioButton, MatRadioGroup } from "@angular/material/radio";
import { TranslatePipe } from "@ngx-translate/core";
import { BsDatepickerConfig, BsDatepickerModule } from "ngx-bootstrap/datepicker";

interface SelectOption {
	value: any;
	label: string;
}

@Component({
	selector: "app-formx-input",
	standalone: true,
	imports: [CommonModule, ReactiveFormsModule, TranslatePipe, BsDatepickerModule, MatRadioButton, MatRadioGroup],
	templateUrl: "./formx-input.component.html",
	styleUrl: "./formx-input.component.scss"
})
export class FormxInputComponent {
	@Input() label!: string;
	@Input() placeholder = "";
	@Input() helperText = "";
	@Input() errorText = "This field is required"; // TODO: Label
	@Input() control!: AbstractControl;
	@Input() type: "text" | "select" | "datepicker" | "radio" | "number" | "email" | "tel" = "text";
	@Input() maxlength?: number;
	@Input() required = false;
	@Input() showNotValidate = false;
	@Input() options: SelectOption[] = [];
	@Input() bsConfig?: Partial<BsDatepickerConfig>;
	@Input() translateLabels = true;
	@Input() disabled = false;
	@Input() vertical = false;

	@Output() change = new EventEmitter<any>();

	get formControl(): FormControl | null {
		return this.control as FormControl;
	}

	get hasError(): boolean {
		return (this.showNotValidate || this.control?.touched) && this.control?.invalid;
	}
}
